import {LastViewDto} from '../../common/shared/api/nicolas/vo/LastViewDto.interface';
import {LastViewInfo} from '../generated/types';

export function createLastViewInfo({
  is_done,
  last_view_dt,
  rate,
  spine_index,
}: LastViewDto): LastViewInfo {
  return {
    lastViewDate: last_view_dt,
    spineIndex: spine_index,
    isDone: is_done,
    rate,
  };
}
